import {domid} from "../../../_js/utils";
import cssProp from "../../../_js/csssupport";

export default function (widget) {
    const m = widget.m;
    const state = widget.state;
    const t = widget.txt;

    const ns = widget.ns + '__timeline';
    const cssTransformProp = cssProp('transform').css; // returns the correct vendor-prefixed CSS property name

    const renderTimelineHours = function (day) {
        const hours = [];
        const maxHrs = day.isLast ? 24 : 23;
        let hour = 0;
        while (hour <= maxHrs) {
            const isPadding = (day.startHrs && hour < day.startHrs) ||
                (day.endHrs && hour > day.endHrs);
            const padClass = isPadding ? ns + '__hour--padding' : '';
            const isMajor = hour % 6 === 0;
            const majorClass = isMajor ? ns + '__hour--major' : '';
            // NOTE only the last day has a 24th hour.
            const lastClass = hour > 23 ? ns + '__hour--verylast' : '';

            const elm = m('li', {className: ns + '__hour' + majorClass + padClass + lastClass},
                !isMajor ? null :
                m('div', {className: ns + '__hour__label'}, hour % 24)
            );
            hours[hour] = elm;
            hour++;
        }
        return hours;
    };

    const renderTimelineDays = function (days) {
        return days.map(function (day) {
            return (
                m('li', {className: ns + '__day'},
                    m('button', {
                            className: ns + '__day__label',
                            onclick: function () {
                                state.setTimelineTime(day.noonTime);
                            },
                            title: t('$timeline__day', {
                                wday: t('$wdays', day.wday),
                                date: day.date,
                                month: t('$months', day.month),
                            }),
                        },
                        t('$timeline__day', {
                            wday: t('$wdays', day.wday),
                            wday_short: t('$wdays--short', day.wday),
                            date: day.date,
                            month: t('$months', day.month),
                            month_short: t('$months--short', day.month),
                        })
                    ),
                    m('ul', {className: ns + '__hours'},
                        renderTimelineHours(day)
                    )
                )
            );
        });
    };


    const timeline = {
        controller: function (/*props*/) {
            const ctrl = this;
            ctrl.domid = domid(ns);

            let timelinePos = 0;
            ctrl.getTimelinePos = function () {
                const days = state.forecastData.timelineDays;
                timelinePos = (state.timepoint.localTime - days.startTime) / days.timespan;
                return timelinePos;
            };

            const dragThreshold = 7;

            let isTouching;
            let wasDragging = false;
            let dragStartX;
            let dragStartPos;

            // ctrl.isDragging = false;

            ctrl.handleTimelineClick = function (e) {
                if (!ctrl.isDragging && !wasDragging) {
                    const elm = e.currentTarget;
                    const clickedElmOffset = (e.target !== elm) ? e.target.offsetLeft : 0;
                    state.setTimelinePos((e.offsetX + clickedElmOffset) / elm.offsetWidth);
                    state.preloadTimepoints();
                    // state.autoStepStop();
                }
            };

            const handleDragStart = function (e) {
                state.autoStepStop();
                if (!e.button) { // Ignore secondary/auxiliary mouse buttons
                    dragStartX = e.touches ? e.touches[0].clientX : e.clientX;
                    dragStartPos = ctrl.getTimelinePos();
                    wasDragging = false;
                    isTouching = true;
                }
            };

            const handleDragging = function (e) {
                if (isTouching) {
                    const xPos = e.touches ? e.touches[0].clientX : e.clientX;
                    const xOffs = dragStartX - xPos;
                    if (!ctrl.isDragging) {
                        ctrl.isDragging = (xOffs < 0 ? -xOffs : xOffs) > dragThreshold;
                    }
                    if (ctrl.isDragging) {
                        // marked as dragging to prevent click event if mouse leaves and enters
                        wasDragging = true;

                        const dragLength = (dragStartX - xPos) / ctrl.timelineElm.offsetWidth;
                        state.setTimelinePos(dragStartPos + dragLength);

                        m.redraw();
                        e.preventDefault();
                    }
                }
            };

            const handleDragEnd = function (/*e*/) {
                isTouching = false;
                dragStartX =
                    dragStartPos =
                        undefined;
                if (ctrl.isDragging) {
                    // Use timeout in order to prevent non-drag-related click events
                    // from making incorrect assumptions about this mouseup/touchend event
                    setTimeout(function () {
                        ctrl.isDragging = false;
                        m.redraw();
                    }, 100);
                }
            };


            let delayedDragActionEnd;

            const handleDragLeave = function (/*e*/) {
                if (ctrl.isDragging) {
                    delayedDragActionEnd = setTimeout(handleDragEnd, 500);
                }
            };
            const handleDragEnter = function (/*e*/) {
                if (ctrl.isDragging) {
                    clearTimeout(delayedDragActionEnd);
                }
            };

            const handleKeyDown = function (e) {
                switch (e.which) {
                    case 37: // LEFT
                        state.shiftTimelineIndex(-1);
                        m.redraw();
                        break;
                    case 39: // RIGHT
                        state.shiftTimelineIndex(1);
                        m.redraw();
                        break;
                    case 27: // ESC
                        state.autoStepStop();
                        m.redraw();
                        break;
                }
            };

            ctrl.setGlobalEvents = function (elm, isRefresh, ctx) {
                if (!isRefresh) {
                    const doc = widget.env.document;
                    doc.addEventListener('keydown', handleKeyDown);
                    elm.addEventListener('mousedown', handleDragStart);
                    elm.addEventListener('touchstart', handleDragStart);
                    doc.addEventListener('mousemove', handleDragging);
                    doc.addEventListener('touchmove', handleDragging);
                    doc.addEventListener('mouseup', handleDragEnd);
                    doc.addEventListener('touchend', handleDragEnd);
                    doc.addEventListener('mouseleave', handleDragLeave);
                    doc.addEventListener('mouseenter', handleDragEnter);

                    ctx.onunload = function () {
                        doc.removeEventListener('keydown', handleKeyDown);
                        elm.removeEventListener('mousedown', handleDragStart);
                        elm.removeEventListener('touchstart', handleDragStart);
                        doc.removeEventListener('mousemove', handleDragging);
                        doc.removeEventListener('touchmove', handleDragging);
                        doc.removeEventListener('mouseup', handleDragEnd);
                        doc.removeEventListener('touchend', handleDragEnd);
                        doc.removeEventListener('mouseleave', handleDragLeave);
                        doc.removeEventListener('mouseenter', handleDragEnter);
                    };
                }
            };

            // const last = {};
            ctrl.maySkipRendering = function () {
                // const maySkip = state.forecastData === last.forecastData  &&
                //               state.forecastType === last.forecastType  &&
                //               ctrl.isVisible === last.isVisible;
                // last.forecastData = state.forecastData;
                // last.forecastType = state.forecastType;
                // last.isVisible = ctrl.isVisible;
                // return maySkip;
            };
        },


        view: function (ctrl/*, props*/) {
            // ctrl.props = props || {};

            if (ctrl.maySkipRendering()) {
                return {subtree: 'retain'};
            }

            const days = state.forecastData.timelineDays;
            const draggingClass = ctrl.isDragging ? ns + '-container--is-dragging' : '';
            return (
                m('div', {
                        className: ns + '-container' + draggingClass,
                        'aria-controls': widget.domid + '__map',
                        'aria-labelledby': ctrl.domid + '__label',
                        config: ctrl.setGlobalEvents,
                    },
                    m('div', {
                            className: ns + '',
                            style: cssTransformProp + ':translateX(-' + (100 * ctrl.getTimelinePos()) + '%)',
                            config: function (elm) {
                                ctrl.timelineElm = elm;
                            }
                        },

                        m('h3', {
                                className: ns + '__label',
                                id: ctrl.domid + '__label',
                            },
                            t('$timeline__label')
                        ),

                        m('ul', {className: ns + '__days'},
                            renderTimelineDays(days)
                        ),

                        m('div', {
                                className: ns + '__hotzone',
                                onclick: ctrl.handleTimelineClick,
                            },
                            m('span', {
                                className: ns + '__hotzone__paddingstart',
                                style: 'width:' + 100 * days.startPad + '%;',
                            }),
                            m('span', {
                                className: ns + '__hotzone__active',
                                style: 'width:' + 100 * (1 - days.startPad - days.endPad) + '%;',
                            }),
                            m('span', {
                                className: ns + '__hotzone__paddingend',
                                style: 'width:' + 100 * days.endPad + '%;',
                            }),
                            m('div', {
                                className: ns + '__hotzone__stale',
                                style: !days.staleTailStart ? 'display:none;' : 'left:' + 100 * days.staleTailStart + '%;' + 'width:' + 100 * days.staleTailLength + '%',
                            })
                        ),

                        m('div', {
                            className: ns + '__currenttime',
                            style: 'left:' + 100 * ((state.localTimeNow - days.startTime) / days.timespan) + '%;',
                        })
                    )
                )
            );
        },

    };


    return timeline;
}
